export default __webpack_public_path__ + "static/media/down.067d5983.svg";